// config.js
// const baseURL = "http://localhost:5000";

const baseURL = "https://advizor-server-d27fd1ef5a20.herokuapp.com";
export default baseURL;
